/** The five UTM keys the app captures off the current URL. */
export const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;

/** Cookie the frontend writes and the signup hook reads. */
export const UTM_COOKIE_NAME = "mb_utm_data";

/** Long window so a late signup still keeps the first UTM. */
export const UTM_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 90; // 90 days
